export function ProdDbWarning() {
    return (
        <div
            style={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 99999,
                backgroundColor: '#dc2626',
                color: '#fff',
                padding: '6px 16px',
                textAlign: 'center',
                fontFamily: 'monospace',
                fontWeight: 'bold',
                fontSize: '13px',
                letterSpacing: '0.05em',
                borderTop: '2px solid #991b1b',
            }}
        >
            ⚠ PRODUCTION DATABASE — huren.test is pointed at prod
        </div>
    );
}
